// extracted by mini-css-extract-plugin
export default {"lds_facebook":"Loader_lds_facebook__aSZlV","center":"Loader_center__VD0um"};